import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { format, formatDistanceStrict } from 'date-fns';
import { es, pt } from 'date-fns/locale';
import i18n from 'src/utils/translate';

const locales = { es, pt };

const RelativeTime = ({className, rawTime}) => {
  const lang = useSelector(({context}) => context.lang);
  const [title, setTitle] = useState('');
  const [display, setDisplay] = useState('');
  // Aurora returns a UTC date string without the "Zulu time" Z for posts and responses
  // TODO: remove this when we use solaris endpoints
  const UTCTime = rawTime.endsWith('0000000', 27) ? rawTime.replace('0000000', '000Z') : rawTime;

  useEffect(() => {
    const now = new Date();
    const then = new Date(UTCTime);

    const getDisplay = () => {
      // if difference is less than 1 minute, just show a few seconds ago
      if ((now - then) < 60000) return i18n.t('A few seconds ago');
      if (Object.keys(locales).includes(lang)) {
        return formatDistanceStrict(then, now, { addSuffix: true, locale: locales[lang] });
      } else {
        // default for date-fns is en-US and is already imported
        return formatDistanceStrict(then, now, { addSuffix: true });
      }
    };

    // Generate display text
    setDisplay(UTCTime ? getDisplay() : '...');
    setTitle(UTCTime ? format(then, 'PPPP p') : '...');
  }, [UTCTime, lang]);

  return (
    <time
      className={className}
      dateTime={UTCTime}
      title={title}
    >
      {display}
    </time>
  );
};

RelativeTime.propTypes = {
  className: PropTypes.string,
  rawTime: PropTypes.string,
};

RelativeTime.defaultProps = {
  rawTime: '',
};

export default RelativeTime;
